/**
 * Date-extensions locale Central Atlas Tamazight Latin [tzm-latn]
 */
import DateExtended from "../date-extended";
DateExtended.addLocale('tzm-latn', {
    monthNames: ['Innayr','Brˤayrˤ','Marˤsˤ','Ibrir','Mayyw','Ywnyw','Ywlywz','ɣwšt','šwtanbir','Ktˤwbrˤ','Nwwanbir','Dwjnbir'],
    monthShortNames: ['Innayr','Brˤayrˤ','Marˤsˤ','Ibrir','Mayyw','Ywnyw','Ywlywz','ɣwšt','šwtanbir','Ktˤwbrˤ','Nwwanbir','Dwjnbir'],
    dayNames: ['Asamas','Aynas','Asinas','Akras','Akwas','Asimwas','Asiḍyas'],
    dayShortNames: ['Asamas','Aynas','Asinas','Akras','Akwas','Asimwas','Asiḍyas']
});
